import {createContext} from "react";

export type ModalContextType = {
    openModalIds: string[];
    openModal: (id: string) => void;
    closeModal: (id: string) => void;
};

export default createContext<ModalContextType>({
    openModalIds: [],
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    openModal: () => {},
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    closeModal: () => {},
});
